import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { List } from 'immutable';
import is from 'is_js';
import { connect, moment } from 'omni-common-ui';
import * as SessionsPaperBased from 'data/PaperBasedHomework';
import { actions as GroupMembers } from 'data/GroupMembers';
import PaperFolding from './PaperFolding';
import { calculatePreviousSession } from 'data/SessionPlans/actions';
import { actions as Group } from 'containers/Group';
import CourseViewTable from 'components/CourseViewTable';
import ReactGA from 'react-ga4';
import { isMarkable } from 'data/PaperBasedHomework/accessors';
import { PaperbasedHomeworkStatus } from 'data/PaperBasedHomework/status';
import { getUnitNumberById, getUnitList } from 'data/Units/accessors';
import PropTypes from 'prop-types';
import styles from './style.postcss';

const MARKING = 'edit';
export const NO_ACTIVE_MARKING_POPUP_TOKEN = -1;

export class MarkHomeworkCourseView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMarkingButtonsToken: NO_ACTIVE_MARKING_POPUP_TOKEN,
      homeworkContentPopupOpenForSessionId: null,
    };
  }

  componentWillMount() {
    this._fetchPaperBased(this.props);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.params && newProps.params.mode !== MARKING) {
      this.setState({
        activeMarkingButtonsToken: NO_ACTIVE_MARKING_POPUP_TOKEN,
      });
    }
  }

  _fetchPaperBased(props) {
    const { fetchGroupPaperBasedHomeworkIfNeeded } = props;
    fetchGroupPaperBasedHomeworkIfNeeded(props.params.groupId);
  }

  _handleShowCellMarkingButtons(activeMarkingButtonsToken) {
    this.setState({
      activeMarkingButtonsToken,
    });
  }

  _handlePaperBasedSaved() {
    this.props.fetchGroupMembers(this.props.params.groupId);
  }

  _handleCloseCellMarkingButtons() {
    this.setState({
      activeMarkingButtonsToken: NO_ACTIVE_MARKING_POPUP_TOKEN,
    });
  }

  _gaChangePaperBased(studentId, currentStatus, nextStatus) {
    ReactGA.event({
      category: 'PaperBasedHomework',
      action: 'Changed paper based homework',
      label: `Changed paper based homework for ${studentId} from ${currentStatus} to ${nextStatus}`,
    });
  }

  _changeStudentPaperBasedStatus(
    sessionId,
    member,
    paperBased,
    newStatus,
    isTutorial,
  ) {
    const { submitMarkPaperBasedHomework } = this.props;
    const modifiedEntityType = isTutorial
      ? 'studentTutorialHomeworks'
      : 'studentPaperBasedHomeworks';
    const modifiedPaperBased = paperBased.update(
      modifiedEntityType,
      (studentHomeworks) =>
        studentHomeworks.map((studentHomework) => {
          if (
            `${studentHomework.studentId}` ===
              `${member.studentGeneralInfo.id}` &&
            studentHomework.homeworkStatus !== newStatus
          ) {
            this._gaChangePaperBased(
              member.studentGeneralInfo.id,
              studentHomework.homeworkStatus,
              newStatus,
            );
            return studentHomework.set(
              'homeworkStatus',
              PaperbasedHomeworkStatus[newStatus && newStatus.toLowerCase()],
            );
          }
          return studentHomework;
        }),
    );
    if (
      is.function(submitMarkPaperBasedHomework) &&
      modifiedPaperBased !== paperBased
    ) {
      submitMarkPaperBasedHomework(sessionId, [modifiedPaperBased]).then(() =>
        this._handlePaperBasedSaved(),
      );
    }
    this.setState({
      isShowingMarkingButtons: false,
      modifiedPaperBased,
    });
  }

  _cellOptions(member, { sessionId, paperBased, markable }) {
    if (!MarkHomeworkCourseView.isInMarkingRoute(this.props) || !paperBased) {
      return;
    }

    const studentPaperBased = paperBased.studentPaperBasedHomeworks.find(
      (att) => `${att.studentId}` === `${member.studentGeneralInfo.id}`,
    );
    if (!studentPaperBased || !markable) {
      return;
    }

    const studentTutorial = paperBased.studentTutorialHomeworks.find(
      (att) => `${att.studentId}` === `${member.studentGeneralInfo.id}`,
    );

    const paperBasedOptions = [
      {
        key: 'complete',
        value: {
          label: 'Complete',
          onClick: () =>
            this._changeStudentPaperBasedStatus(
              sessionId,
              member,
              paperBased,
              PaperbasedHomeworkStatus.complete,
            ),
        },
      },
      {
        key: 'partialcomplete',
        value: {
          label: 'Partial Complete',
          onClick: () =>
            this._changeStudentPaperBasedStatus(
              sessionId,
              member,
              paperBased,
              PaperbasedHomeworkStatus.partialcomplete,
            ),
        },
      },
      {
        key: 'incomplete',
        value: {
          label: 'Incomplete',
          onClick: () =>
            this._changeStudentPaperBasedStatus(
              sessionId,
              member,
              paperBased,
              PaperbasedHomeworkStatus.incomplete,
            ),
        },
      },
      {
        key: 'notapplicable',
        value: {
          label: 'Not Applicable',
          onClick: () =>
            this._changeStudentPaperBasedStatus(
              sessionId,
              member,
              paperBased,
              PaperbasedHomeworkStatus.notapplicable,
            ),
        },
      },
    ];

    if (studentTutorial && studentTutorial.size > 0) {
      const tutorialOptions = [
        {
          key: 'tcomplete',
          value: {
            label: 'Complete',
            onClick: () =>
              this._changeStudentPaperBasedStatus(
                sessionId,
                member,
                paperBased,
                PaperbasedHomeworkStatus.complete,
                true,
              ),
          },
        },
        {
          key: 'tpartialcomplete',
          value: {
            label: 'Partial Complete',
            onClick: () =>
              this._changeStudentPaperBasedStatus(
                sessionId,
                member,
                paperBased,
                PaperbasedHomeworkStatus.partialcomplete,
                true,
              ),
          },
        },
        {
          key: 'tincomplete',
          value: {
            label: 'Incomplete',
            onClick: () =>
              this._changeStudentPaperBasedStatus(
                sessionId,
                member,
                paperBased,
                PaperbasedHomeworkStatus.incomplete,
                true,
              ),
          },
        },
        {
          key: 'tnotapplicable',
          value: {
            label: 'Not Applicable',
            onClick: () =>
              this._changeStudentPaperBasedStatus(
                sessionId,
                member,
                paperBased,
                PaperbasedHomeworkStatus.notapplicable,
                true,
              ),
          },
        },
      ];

      tutorialOptions.forEach((item, index) =>
        paperBasedOptions.splice(2 * index + 1, 0, item),
      );
    }

    const options = {};
    paperBasedOptions.forEach((item) => {
      options[item.key] = item.value;
    });

    return options;
  }

  _onHomeworkContentPopupOkClicked() {
    this.setState({ homeworkContentPopupOpenForSessionId: null });
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      location: window.location.href,
      title: document.title,
    });
  }

  _setHighlightedColumnsNo(paperBased, defaultSession) {
    const firstIndexOfHighlightedColumn = paperBased.reduce(
      (startIndex, sessionsPaperBased) => {
        if (sessionsPaperBased.first().sessionIndex < defaultSession.index) {
          return startIndex + sessionsPaperBased.size;
        }
        return startIndex;
      },
      0,
    );
    const highlightedColumnSize =
      paperBased.get(`${defaultSession.id}`) &&
      paperBased.get(`${defaultSession.id}`).size;
    const highlightedColumns = [];
    for (let i = 0; i < highlightedColumnSize; i++) {
      highlightedColumns[i] = firstIndexOfHighlightedColumn + i;
    }
    return highlightedColumns;
  }

  _sortLesson(a, b) {
    if (a.unitOrderingSequence !== b.unitOrderingSequence) {
      return a.unitOrderingSequence - b.unitOrderingSequence;
    }
    return a.lessonNumber - b.lessonNumber;
  }

  render() {
    const { members, sessionPlans, paperBased, markableSessionIds } =
      this.props;
    if (!List.isList(members) || !List.isList(sessionPlans)) {
      return null;
    }
    const defaultSession = calculatePreviousSession(sessionPlans);
    const defaultSessionIndex =
      paperBased &&
      paperBased.size > 0 &&
      this._setHighlightedColumnsNo(paperBased, defaultSession);
    return (
      <div>
        <CourseViewTable
          students={members}
          highlightedColumns={defaultSessionIndex}
        >
          <CourseViewTable.Header>
            <CourseViewTable.Row>
              {paperBased.map((sessionPaperBased) =>
                sessionPaperBased
                  .sort(this._sortLesson)
                  .map((lessonPaperBased) => {
                    const columnId = {
                      sessionId: lessonPaperBased.sessionId,
                      paperBased: lessonPaperBased,
                      markable: markableSessionIds.includes(
                        lessonPaperBased.sessionId,
                      ),
                    };

                    return (
                      <CourseViewTable.Cell columnId={columnId} small>
                        <span className={styles.MarkHomeworkCourseView_header}>
                          {`S${lessonPaperBased.sessionIndex}, U${lessonPaperBased.unitOrderingSequence}, L${lessonPaperBased.lessonNumber}`}
                        </span>
                      </CourseViewTable.Cell>
                    );
                  }),
              )}
            </CourseViewTable.Row>
            <CourseViewTable.Row>
              {paperBased.map((sessionPaperBased) =>
                sessionPaperBased.map((lessonPaperBased) => {
                  const { timeZone } = this.props;
                  const currentSessionPlan = sessionPlans.find(
                    (plan) => plan.id === lessonPaperBased.sessionId,
                  );
                  const date = moment
                    .parseZone(currentSessionPlan.period.start)
                    .clone()
                    .tz(timeZone);
                  return (
                    <CourseViewTable.Cell>
                      <time dateTime={date.format('YYYY-MM-DD')}>
                        {date.format('ddd')}
                        <br />
                        {date.format('D')}&nbsp;{date.format('MMM')}
                      </time>
                    </CourseViewTable.Cell>
                  );
                }),
              )}
            </CourseViewTable.Row>
          </CourseViewTable.Header>
          <CourseViewTable.Body
            firstOptionHeader="Practice Book"
            secondOptionHeader="Tutorial Book"
            cellOptions={(...args) => this._cellOptions(...args)}
          >
            {(member, column) => {
              const studentPaperBased =
                column.paperBased &&
                column.paperBased.studentPaperBasedHomeworks &&
                column.paperBased.studentPaperBasedHomeworks.find(
                  (att) =>
                    `${att.studentId}` === `${member.studentGeneralInfo.id}`,
                );
              const studentTutorial =
                column.paperBased &&
                column.paperBased.studentTutorialHomeworks &&
                column.paperBased.studentTutorialHomeworks.find(
                  (att) =>
                    `${att.studentId}` === `${member.studentGeneralInfo.id}`,
                );
              const paperBasedStatus =
                studentPaperBased && studentPaperBased.homeworkStatus;
              const tutorialStatus =
                studentTutorial && studentTutorial.homeworkStatus;
              return (
                <div className={styles.MarkHomeworkCourseView_content}>
                  {column.markable ||
                  (paperBasedStatus && paperBasedStatus !== 'UnMarked') ? (
                    <PaperFolding paperBasedStatus={paperBasedStatus} />
                  ) : (
                    '-'
                  )}
                  {column.markable && tutorialStatus ? (
                    <PaperFolding paperBasedStatus={tutorialStatus} />
                  ) : null}
                </div>
              );
            }}
          </CourseViewTable.Body>
        </CourseViewTable>
      </div>
    );
  }
}

MarkHomeworkCourseView.isInMarkingRoute = (props) =>
  props.params && props.params.mode === MARKING;

MarkHomeworkCourseView.propTypes = {
  timeZone: PropTypes.string.isRequired,
  members: PropTypes.shape().isRequired,
  sessionPlans: PropTypes.shape().isRequired,
  markableSessionIds: PropTypes.shape().isRequired,
  paperBased: PropTypes.shape().isRequired,
  params: PropTypes.shape().isRequired,
  fetchGroupMembers: PropTypes.func,
  fetchGroupPaperBasedHomeworkIfNeeded: PropTypes.func.isRequired,
  submitMarkPaperBasedHomework: PropTypes.func.isRequired,
};

export function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const group = state.get('rootReducer').get('groups').get(groupId);
  const units = getUnitList(state, groupId);
  const sessionPlans = new List(group.data.sessionPlans.data).map((id) =>
    state.get('rootReducer').get('sessionPlans').get(id),
  );
  const markableSessionIds = sessionPlans
    .filter((plan) => isMarkable(state, groupId, plan.id))
    .map((plan) => plan.id);
  let paperBasedFilterByGoup = state
    .get('rootReducer')
    .get('paperBasedHomework')
    .filter(
      (data, id) =>
        sessionPlans.find(
          (session) => session && `${session.id}` === `${id}`,
        ) && data.size > 0,
    );
  paperBasedFilterByGoup = paperBasedFilterByGoup.map((sessionPaperBased) =>
    sessionPaperBased.map((paperBased) =>
      paperBased
        .set(
          'unitOrderingSequence',
          getUnitNumberById(units, `${paperBased.unitId}`),
        )
        .set(
          'sessionIndex',
          sessionPlans.find((plan) => plan.id === `${paperBased.sessionId}`)
            .index,
        ),
    ),
  );
  return {
    timeZone: Group.getCentre(state, groupId).timeZone,
    members: GroupMembers.getMembersByGroup(state, groupId),
    sessionPlans,
    markableSessionIds,
    paperBased: paperBasedFilterByGoup.sortBy(
      (sessionPaperBased) => sessionPaperBased.first().sessionIndex,
    ),
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    bindActionCreators(SessionsPaperBased.actions, dispatch),
    bindActionCreators(GroupMembers, dispatch),
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MarkHomeworkCourseView);



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkCourseView/component.jsx